export default __webpack_public_path__ + "static/media/maure_de_bretagne.a89be2d2.jpg";